import { useState } from "react";
import { FileText, Download, Play } from "lucide-react";
import { attachmentUrl, humanSize } from "@/lib/upload";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function MessageAttachments({ attachments }) {
  const [preview, setPreview] = useState(null);
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="mt-2 flex flex-col gap-2 max-w-md">
      {attachments.map((att) => {
        const url = attachmentUrl(att);
        if (att.kind === "image") {
          return (
            <button
              key={att.id}
              onClick={() => setPreview(url)}
              className="block overflow-hidden rounded-xl border border-[#2E3242] hover:border-red-900/50 transition-colors max-w-xs"
              data-testid={`attachment-image-${att.id}`}
            >
              <img src={url} alt={att.filename} className="w-full max-h-72 object-cover" />
            </button>
          );
        }
        if (att.kind === "audio") {
          return (
            <div
              key={att.id}
              data-testid={`attachment-audio-${att.id}`}
              className="rounded-xl border border-[#2E3242] bg-[#1E2029] px-3 py-2.5 max-w-xs"
            >
              <p className="text-[11px] text-gray-400 mb-1.5 flex items-center gap-1.5">
                <Play className="w-3 h-3 text-red-400" /> Voice note
              </p>
              <audio controls src={url} className="w-full h-9" />
            </div>
          );
        }
        if (att.kind === "video") {
          return (
            <video
              key={att.id}
              data-testid={`attachment-video-${att.id}`}
              controls
              src={url}
              className="rounded-xl border border-[#2E3242] max-w-xs max-h-72"
            />
          );
        }
        return (
          <a
            key={att.id}
            href={attachmentUrl(att, { download: true })}
            data-testid={`attachment-file-${att.id}`}
            className="flex items-center gap-3 rounded-xl border border-[#2E3242] bg-[#1E2029] px-3 py-2.5 hover:border-red-900/50 transition-colors group max-w-xs"
          >
            <span className="w-9 h-9 rounded-lg bg-red-950/50 border border-red-900/40 flex items-center justify-center shrink-0">
              <FileText className="w-4 h-4 text-red-300" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm text-gray-200 truncate">{att.filename}</span>
              <span className="block text-[11px] text-gray-500">{humanSize(att.size)}</span>
            </span>
            <Download className="w-4 h-4 text-gray-500 group-hover:text-red-300" />
          </a>
        );
      })}

      <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
        <DialogContent className="max-w-4xl bg-[#0B0C10] border-[#2E3242] p-2">
          {preview && <img src={preview} alt="" className="w-full max-h-[80vh] object-contain rounded-lg" />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
